import dayjs from "dayjs";
import { LinehaulTrailers } from "../../hooks/react-query/outbound/linehaulTrailers/useLinehaulTrailers";

export const linehaulTrailersResponse = {
  empty: {
    summary: {
      bills: 0,
      pieces: 0,
      pallets: 0,
      weight: 0,
      trailers: 0,
    },
    trailers: [],
  },
  default: {
    summary: {
      bills: 14,
      pieces: 178,
      pallets: 28,
      weight: 16002,
      trailers: 2,
    },
    trailers: [
      {
        tripNumber: 3001249,
        trailerNumber: "DYLT161615",
        etaDate: dayjs("2024-03-18"),
        etaTime: "00:52",
        etaTimeStamp: dayjs("2024-03-01T00:00:00"),
        serviceDue: new Date("2024-03-01T00:00:00"),
        originSic: "ONT",
        destinationSic: "DAL",
        stopOffSicCode: "EWR",
        bills: 7,
        pieces: 89,
        pallets: 14,
        weight: 8001,
        shipmentTags: [
          {
            id: 81,
            name: "VC",
            color: "#AA7EA0",
            description: "Vendor Compliance",
          },
          {
            id: 5,
            name: "APTM",
            color: "#69ADA8",
            description: "Appointment Made",
          },
          {
            id: 9,
            name: "DTCL",
            color: "#5E9FE0",
            description: "Delivery to Connecting Line",
          },
        ],
        status: "CPLN",
        doorNumber: null,
        workerName: null,
        isPlanned: true,
      },
      {
        tripNumber: 3001250,
        trailerNumber: "DYLT161616",
        etaDate: dayjs("2024-03-18"),
        etaTime: "01:30",
        etaTimeStamp: dayjs("2024-03-01T01:30:00"),
        serviceDue: new Date("2024-03-01T01:30:00"),
        originSic: "LAX",
        destinationSic: "DAL",
        stopOffSicCode: null,
        bills: 7,
        pieces: 89,
        pallets: 14,
        weight: 8001,
        shipmentTags: [
          {
            id: 81,
            name: "VC",
            color: "#AA7EA0",
            description: "Vendor Compliance",
          },
        ],
        status: "ENRT",
        doorNumber: null,
        workerName: null,
        isPlanned: false,
      },
    ],
  },
} as const satisfies Record<string, LinehaulTrailers>;
